(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9930],{

/***/ 97751:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom",
      function () {
        return __webpack_require__(43652);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function CardCTA(param) {
    var className = param.className, label = param.label;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('rounded border border-rose py-2 px-4 text-sm font-bold text-rose group-hover:border-cornflower group-hover:text-cornflower', className),
        children: [
            label,
            " →"
        ]
    }));
};


/***/ }),

/***/ 83228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function CardLink(param) {
    var children = param.children, className = param.className, externalUrl = param.externalUrl, linkPath = param.linkPath;
    var linkClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex flex-1 flex-col group');
    if (externalUrl) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: externalUrl,
            target: "_blank",
            rel: "nofollow noopener noreferrer",
            className: linkClassName,
            children: children
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
        href: linkPath,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: linkClassName,
            children: children
        })
    }));
};


/***/ }),

/***/ 16190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DefaultCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var _components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37324);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27910);
/* harmony import */ var _components_CardLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83228);
/* harmony import */ var _components_CardCTA__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13690);






function DefaultCard(param) {
    var coverImage = param.coverImage, externalUrl = param.externalUrl, linkPath = param.linkPath, id = param.id, subTitle = param.subTitle, title = param.title;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: "flex flex-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_CardLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            externalUrl: externalUrl,
            linkPath: linkPath,
            children: [
                coverImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "rounded-lg",
                        src: coverImage.url,
                        width: coverImage.width,
                        height: coverImage.height,
                        alt: coverImage === null || coverImage === void 0 ? void 0 : coverImage.alt
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "-mt-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        level: 4,
                        className: "mb-2",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "flex-grow",
                    children: subTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardCTA__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        label: "Learn More"
                    })
                })
            ]
        })
    }, id));
};


/***/ }),

/***/ 43652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Newsroom; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Layout/Vanilla.tsx + 22 modules
var Vanilla = __webpack_require__(1635);
// EXTERNAL MODULE: ./src/components/Hero.js + 5 modules
var Hero = __webpack_require__(52456);
// EXTERNAL MODULE: ./src/components/Section.tsx
var Section = __webpack_require__(67576);
// EXTERNAL MODULE: ./node_modules/@sindresorhus/slugify/index.js
var slugify = __webpack_require__(46831);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./src/components/DefaultCard.js
var DefaultCard = __webpack_require__(16190);
;// CONCATENATED MODULE: ./src/components/CardList.js



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CardList(param) {
    var _entries = param.entries, entries = _entries === void 0 ? [] : _entries, _Component = param.Component, Component = _Component === void 0 ? DefaultCard/* default */.Z : _Component, linkSubpath = param.linkSubpath;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "space-y-6 md:space-y-12",
        children: entries.map(function(entry) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Component, _objectSpread({
                linkPath: "/".concat(linkSubpath, "/").concat(slugify_default()(entry.slug, {
                    lower: true
                }))
            }, entry), entry.id);
        })
    }));
};

// EXTERNAL MODULE: ./src/components/Authors.js
var Authors = __webpack_require__(56794);
// EXTERNAL MODULE: ./src/components/CardLink.js
var CardLink = __webpack_require__(83228);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(63049);
;// CONCATENATED MODULE: ./src/components/NewsroomCard.js




function NewsroomCard(param) {
    var authors = param.authors, externalUrl = param.externalUrl, linkPath = param.linkPath, id = param.id, title = param.title, publishedOn = param.publishedOn, subTitle = param.subTitle;
    var friendlyPublishedOn = (0,date/* formatDate */.p)(publishedOn);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CardLink/* default */.Z, {
        externalUrl: externalUrl,
        linkPath: linkPath,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col md:flex-row md:items-start md:space-x-2",
            children: [
                authors && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-ml-px flex w-full max-w-[75px] items-center justify-start md:mt-1 md:justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Authors/* default */.Z, {
                        people: authors,
                        expand: false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg text-haiti group-hover:text-rose md:text-xl",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm text-mid-gray md:text-base",
                                    children: subTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-xs font-medium text-haiti md:text-sm",
                                    children: [
                                        "Published on ",
                                        friendlyPublishedOn
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, id));
};

;// CONCATENATED MODULE: ./src/pages/newsroom/index.js






function newsroom_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function newsroom_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            newsroom_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __N_SSG = true;
function Newsroom(param) {
    var page = param.page, newsrooms = param.newsrooms, preview = param.preview;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Vanilla/* default */.Z, {
        seo: page,
        preview: preview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, newsroom_objectSpread({}, page)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                container: "narrow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardList, newsroom_objectSpread({
                    entries: newsrooms,
                    Component: NewsroomCard,
                    linkSubpath: "newsroom"
                }, page))
            })
        ]
    }));
};


/***/ }),

/***/ 63049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; },
/* harmony export */   "k": function() { return /* binding */ formatDateWithTime; }
/* harmony export */ });
var normalizeDate = function(dateToNormalize) {
    var date = new Date(dateToNormalize);
    return new Date(date.getTime() - date.getTimezoneOffset() * -60000);
};
function formatDate(date) {
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
    }).format(normalizeDate(date));
}
function formatDateWithTime(date) {
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false
    }).format(normalizeDate(date));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,3353,6831,5343,1635,2456,9774,2888,179], function() { return __webpack_exec__(97751); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);